import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-nav" }
const _hoisted_2 = { class: "admin-nav-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, "어신 백오피스", -1)
const _hoisted_4 = { class: "admin-menu" }
const _hoisted_5 = { class: "menu-list" }
const _hoisted_6 = /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-building fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" Dashboard ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-building fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" 파트너스 가입 내역 ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-database fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" 파트너스 조황 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/default",
        class: "admin-nav-link"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("ul", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/partners",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/partners/join",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/partners/fishing-result",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ])
  ]))
}